import { request } from '@h3/request';
import * as Api from './constant';
import * as Attendance from './attendance';
import * as Connect from './connect';
import * as Email from './email';
import * as Esign from './esign';
import * as Ocr from './ocr';
import * as Payment from './payment';
import * as Sms from './sms';
import * as FaceRecognition from './face-recognition';
import * as RobotNotification from './robot-notification';
import * as SyncRule from './sync';
import * as PluginNext from './next';
import * as WxChat from './wxChat';
import * as SceneGroup from './scenegroup';
import * as DataSpeak from './data-speak';
/** 获取插件列表 */
export const getPluginList = () => request(Api.PluginList, {
    method: 'post',
});
/** 插件调用 */
export const invokePlugin = () => request(Api.PluginInvoke, {
    method: 'post',
});
/** 添加插件 */
export const addPlugin = (params) => request(Api.PluginAdd, {
    method: 'post',
    data: params,
});
/** 删除插件 */
export const removePlugin = (params) => request(Api.PluginRemove, {
    method: 'post',
    data: params,
});
export { Attendance, Connect, Email, Esign, Ocr, Payment, Sms, FaceRecognition, RobotNotification, SyncRule, PluginNext, WxChat, SceneGroup, DataSpeak, };
